<template>
    <div class="w-100">
        <c-drop-message
            v-if     = "drag.notAllowed"
            :message ="drag.message"
            style="margin-left: 0"
        />

        <drop
            v-if          = "bid"
            class         = "cut h-100 w-100"
            @drop         = "onDropBid"
            mode          = "cut"
            :accepts-type = "onAcceptTypeBid"
            :accepts-data = "() => bid.status.id !== 0"
            ref ="droparea"
        >
            <div class="bid-panel">
                <div
                    v-if  = "bid.favorite"
                    class = "favorite primary white--text v-flex"
                    style = "border-radius: 4px"
                >
                    <span><i class="fas fa-star pr-1"></i>{{ $t("repair.bid.label.favorite") }}</span>
                </div>
                <div v-if="!bid.favorite" class="not-favorite primary--text">
                    <v-menu
                        v-model="favoriteselect"
                        offset-y
                        :close-on-content-click="false"
                        class="pa-0"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div class="v-flex">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    depressed
                                    color="white"
                                    class="pr-8"
                                >
                                    <span><i class="far fa-star"></i></span>

                                    <v-checkbox
                                        class="mr-0"
                                        :ripple="false"
                                        color="primary"
                                        v-model="bid.active"
                                        @click.stop="onBid"
                                    />

                                    <div class="primary--text" style="margin-left: -10px;">
                                        {{ bidname }}
                                    </div>
                                    <v-spacer />
                                </v-btn>
                            </div>
                        </template>

                        <div class="favorite-query-container">
                            <div>{{ $t("repair.bid.query.favorite") }}</div>
                            <div class="query-buttons">
                                <v-btn
                                    rounded
                                    width="100"
                                    color="primary"
                                    @click="onFavorite"
                                >{{ $t("common.yes") }}
                                </v-btn>
                                <div style="width: 10px"></div>
                                <v-btn
                                    rounded
                                    width="100"
                                    @click="favoriteselect=false"
                                >{{ $t("common.no") }}
                                </v-btn>
                            </div>
                        </div>
                    </v-menu>
                </div>

                <c-flip-card
                    v-model  = "flipped"
                    :top     = "top"
                    :right   = "10"
                    :color   = "bid.favorite?'white--text':'#0a68b8'"
                    :enabled = "bid.active"
                >
                    <template v-slot:front>
                        <div class="bid-front white">
                            <v-row class="no-frame mt-2" v-show="!bid.active && hasDocuments(bid.active)">
                                <v-col class="no-frame error--text">
                                    {{ $t("repair.bid.document.deletehint") }}
                                </v-col>
                            </v-row>

                            <v-row class="no-frame mt-1 mb-2 lm-border pl-2 pr-2" v-show="bid.active">
                                <v-col class="no-frame">
                                    <inc-status
                                        :items  = "bidstatus"
                                        v-model = "bid.status"
                                        class   = "mt-2 mb-3"
                                        :hide-details = "true"
                                        :background = "collective ? 'field-group-background-blue' : ''"
                                        @change = "onStatusChange"
                                    />
                                </v-col>
                            </v-row>

                            <v-row class="no-frame  lm-border">
                                <v-col class="no-frame">
                                    <v-row
                                        class="no-frame"
                                        v-show="bid.active"
                                    >
                                        <v-col class="no-frame">
                                            <inc-manufacturer
                                                class="pa-2 pt-1 pb-0"
                                                v-model = "bid.manufacturer"
                                                :hint   = "manufacurerHint"
                                                :rules  = "[requiredRule]"
                                                @input  = "onManfacturerChange"
                                                :background = "sites.length > 1 ? 'field-group-background-blue' : ''"
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row class="no-frame" v-show="bid.active" style="height: 105px">
                                        <c-contact-select
                                            v-if        = "bid.manufacturer"
                                            v-model     = "bid.contactIds"
                                            label       = "Kontakte"
                                            class       = "w-100 pl-2 pr-2 mt-n1"
                                            :company-id = "bid.manufacturer ? bid.manufacturer.id : null"
                                            :incident   = "incident"
                                            :index      = "index"
                                            :status     = "bid.status"
                                            :background = "collective ? 'field-group-background-blue' : 'white'"
                                            @sendmail   = "onSendmail"

                                        />
                                    </v-row>
                                </v-col>
                            </v-row>


                            <v-row class="no-frame mt-2 lm-border pa-2 pt-1 pb-3" v-show="bid.active">
                                <v-col class="no-frame mr-2">
                                    <v-text-field
                                        :label         = "$t('repair.bid.label.number')"
                                        v-model        = "bid.number"
                                        :rules         = "[requiredRule]"
                                        :background-color = "sites.length > 1 ? 'field-group-background-blue' : ''"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                        hide-details
                                    />
                                </v-col>
                                <v-col class="no-frame ml-2">
                                    <f-enum-select
                                        v-model   = "bid.deliverytime"
                                        :label    = "$t('invoice.deliverytimes')"
                                        :readonly = "readonly"
                                        module    = "inc"
                                        type      = "deliverytimes"
                                        :background = "sites.length > 1 ? 'field-group-background-blue' : ''"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>

                            <div v-if="bid.active && sites.length > 1" class="mt-6 mb-3">
                                <inc-calculation-sum
                                    :calculations = "bid.calculations"
                                    :navigation   = "true"
                                    :collective   = "collective"
                                    :border       = "true"
                                    @navigate     = "onZoom"
                                />
                            </div>

                            <div v-if="bid.active" class="mt-6">
                                <inc-calculation
                                    v-if="bidUnitData"
                                    :form     = "form"
                                    :data     = "bidUnitData"
                                    :status   = "bid.status"
                                    :favorite = "bid.favorite"
                                    :notice   = "sites.length === 0"
                                    :title    = "'Kalkulation Anlage ' + $store.getters.site.fabricNo"
                                    :border   = "true"
                                    :compact="false"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-slot:back>
                        <div class="white" style="height: calc(100% - 10px); width: calc(100% + 1px)">
                            <inc-bid-documents
                                v-if           = "data && bid.status.id !== 0"
                                :collection-id = "data.id"
                                :bid-id        = "bid.id"
                                :bid-name      = "bidname"
                                :data          = "data"
                                ref            = "biddocs"
                            />
                        </div>
                    </template>
                </c-flip-card>
            </div>
        </drop>
    </div>
</template>

<script>

import { Drop, DragAwareMixin }          from "vue-easy-dnd"
import Core              from "@/modules/core/service/Core";
import Inc               from "@/modules/inc/service/Inc";
import Inb               from "@/modules/inb/service/Inb";
import CFlipCard         from "@/modules/core/components/utils/CFlipCard.vue";
import IncStatus         from "@/modules/inc/steps/components/common/IncStatus.vue";
import IncManufacturer   from "@/modules/inc/steps/components/common/IncManufacturer.vue";
import IncBidDocuments   from "@/modules/inc/steps/components/repair/private/IncBidDocuments.vue";
import IncCalculation    from "@/modules/inc/steps/components/repair/private/IncCalculation.vue";
import IncCalculationSum from "@/modules/inc/steps/components/repair/private/IncCalculationSum.vue";
import FEnumSelect       from "@/modules/core/components/utils/FEnumSelect.vue";
import CContactSelect    from "@/modules/msd/company/contact/components/controlls/CContactSelect.vue";
import CDropMessage from "@/modules/inc/steps/components/common/CDropMessage.vue";

const Const = {
    flip: {
        button: {
            top: -22,
        }
    }
};

export default {
    name: "IncBid",

    mixins: [DragAwareMixin],

    components: {
        CDropMessage,
        CContactSelect,
        FEnumSelect,
        IncCalculation,
        IncCalculationSum,
        IncBidDocuments,
        CFlipCard,
        IncManufacturer,
        IncStatus,
        Drop,
    },

    props: {
        bid: {
            required: false,
            type: Object,
            default: function () {
                return null;
            }
        },
        data: {
            required: true,
            type: Object
        },
        status: {
            required: true,
            type: Array
        },
        incident: {

        },
        sites: {
            required: true,
        },
        bus: {

        },
        index: {

        },
        step: {

        },

        form: {

        },

        readonly: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },
    },

     data: () => ({
         drag: {
             notAllowed: false,
             message   : null
         },

        favoriteselect: false,
        manufacurerHint: "",
        flipped: false,
        top: Const.flip.button.top,
        refresh: 0,
        selectedContacts: []
    }),

    computed: {
        requiredRule() {
            if (Inc.step.canceled(this.bid.status)) {
                return true;
            }

            return !this.bid.active || (v => !!v || this.$t("rules.required"));
        },

        emailRule() {
            return Core.rule.email;
        },

        bidstatus() {
            return this.status;
        },

        bidname () {
            return this.$t("repair.bid.name." + this.bid.bidname);
        },

        bidUnitData () {
            const unit = this.$store.getters.site;
            if (!unit) {
                return null;
            }

            return this.bid.calculations.find (data => data.unit.id === unit.id);
        },

        collective () {
            return this.sites.length > 1
        },

    },

    created() {
        this.$bus.$on(this.$events.drag.end, this.onDragend);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.drag.end, this.onDragend);
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.biddocs.load();
        })
    },

    watch: {
        bid () {
            this.$refs.biddocs.load();
        }
    },

    methods: {
        onFavorite() {
            this.$emit("favorite", this.bid.bidname)
            this.favoriteselect = false;
        },

        onZoom() {
            this.$emit("zoom", this.bid)
        },

        isUnique(value) {
            if (!this.bid.manufacturer) {
                return true;
            }

            const items = this.data.bids.filter(bid => {
                if (!bid.active) return false;
                return bid.manufacturer && (bid.manufacturer.id === value.id)
            });

            return items.length === 1;
        },

        onStatusChange () {
            this.form.validate()
            if (this.bid.favorite) {
                this.$emit("status-changed", this.bid.status);
            }
        },

        onManfacturerChange(value) {
            if (!this.isUnique(value)) {
                this.manufacurerHint = this.$t("repair.bid.rules.manufacturer");
            } else {
                this.manufacurerHint = null;
            }
        },

        onDropBid (event) {
            if (event.type.type !== "inbox" ) {
                return;
            }

            this.$emit("save", () => {
                Inb.attach(this, event.data.data.id, this.incident.id, this.step, { id: this.bid.id, name: this.bid.bidname }, true, (message) => {
                    this.flipped = true;
                    this.$refs.biddocs.load();
                    this.$emit("refresh", message);
                });
            });
        },

        onSendmail (mail) {
            mail.bidId = this.bid.id;
            mail.callback = () => {
                this.$refs.biddocs.load();
            };
            this.$emit("sendmail", mail)
        },

        onAcceptTypeBid (message) {
            const pos  = this.dragPosition;
            if (!this.contains(pos.x, pos.y)) {
                this.drag.notAllowed = false;
                return false;
            }

            if (!this.bid.active) {
                return false;
            }

            if (!(message instanceof Object) || message.type === "dms-document") {
                return;
            }

            const accept = Inc.clipboard.accept(message, this.incident, [{
                message : "BID",
                incident: null
            }, {
                message : "ORDERPLACEMENT",
                incident: null
            }, {
                message : "DEFAULT",
                incident: null
            }, {
                message: "ORDER",
                incident: null
            }, {
                message: "WORKREPORT",
                incident: null
            }, {
                message: "IMAGE",
                incident: null
            },{
                message: "CORRESPONDENCE",
                incident: null
            },
            ], false, true);

            this.drag.notAllowed = !accept.valid;
            this.drag.message    = this.$t(accept.message);

            return accept.valid;
        },

        onDragend () {
            this.drag.notAllowed = false;
        },

        onBid () {
            this.$emit("save")
        },

        hasDocuments () {
            if (!this.$refs.biddocs) {
                return false;
            }

            return this.$refs.biddocs.count() > 0;
        },

        contains (x, y) {
            const rect = this.$refs.droparea.$el.getBoundingClientRect();
            return rect.x <= x && x <= rect.x + rect.width &&
                rect.y <= y && y <= rect.y + rect.height;
        }
    }
}
</script>

<style scoped>

.bid-panel {
    height: 645px;
    width: 100%
}

.bid-front {
    overflow-y: scroll;
    max-height: 630px;
    width: calc(100% + 10px);
    overflow-x: hidden;
    padding-right: 4px;
}

.favorite,
.not-favorite {
    width: 100%;
    height: 30px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 11pt;
    padding-top: 4px;
}

.not-favorite {
    border-style: solid;
    border-width: 1px;
    padding: 0;
}

.favorite-query-container,
.not-favorite {
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
}

.query-buttons {
    display: flex;
    width: 100%;
    justify-content: center;
    padding-top: 20px;
}

.not-favorite button {
    width: 100%;
    padding: 0;
    text-transform: unset;
    letter-spacing: unset;
    background-color: white;
    font-size: 11pt;
    justify-content: space-between;
    height: 28px !important;
    font-weight: normal;
}

.favorite-query-container {
    width: 100%;
    height: 140px;
    margin-top: 5px;
    text-align: center;
    padding-top: 25px;
    font-size: 11pt;
    background-color: white;
}

.money ::v-deep input {
    text-align: right;
}

::v-deep .v-select__selections {
    max-height: 54px;
}

</style>